class Navigation {
	constructor() {
		this.header = document.getElementById("site-navigation");
		this.mobileNav = document.querySelector(".navbar-menu-container");
		this.openMenu = document.getElementById("open-nav");
	}
	init() {
		if (!this.header && !this.mobileNav && !this.openMenu) return;

		this.openMenu?.addEventListener("click", () => {
			this.header.classList.toggle("shadow");
			this.header.classList.toggle("is-open");
			this.openMenu.classList.toggle("is-active");
			this.mobileNav.classList.toggle("is-active");
		});
	}
}

export default Navigation;
